// Copyright (C) 2017-2023 Smart code 203358507

const NextVideoPopup = require('./NextVideoPopup');

module.exports = NextVideoPopup;
